import React from "react";
import { CourseFinanceCategoryApi, courseFinanceCategoriesApi } from "api/course-finances/courseFinanceCategoriesApi";
import {
  AdminResourceDeleteModal,
  AdminSearchInput,
  FiltersBackground,
  HeaderWithBreadcrumbs,
  PageMain,
} from "components/molecules";
import { routes } from "consts";
import { useNavigate } from "react-router-dom";
import { PaziaButton } from "components/atoms";
import {
  TanTable,
  TanTableColumn,
  useFilters,
  usePagination,
  useSorting,
} from "components/molecules";
import { useCourseFinanceCategories } from "api/course-finances";
import { useDeleteResourceActions } from "utils/store";

export const FinanceCategoriesPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { setDeleteResource } = useDeleteResourceActions();

  const { searchPhrase, filter, setSearchPhrase } = useFilters();
  const { limit, skip, onPaginationChange, pagination } = usePagination();
  const { sorting, onSortingChange, fieldWithOrder } = useSorting();
  const { isLoading, isFetching, categories, total, invalidate } = useCourseFinanceCategories(
    skip,
    limit,
    searchPhrase,
    filter,
    fieldWithOrder,
  );
  const columns = React.useMemo<TanTableColumn<CourseFinanceCategoryApi>[]>(
    () => [
      {
        id: "id",
        header: "ID",
        accessorKey: "id",
        enableColumnFilter: false,
        size: 10,
      },
      {
        id: "name",
        header: "Nazwa",
        accessorKey: "name",
        enableColumnFilter: false,
      },
    ],
    [],
  );

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        headerText="Kategorie płatności"
        headerButton={
          <PaziaButton type="primary" title="Dodaj +" onClick={() => navigate(routes.COURSE_FINANCES_CATEGORIES_ADD)} />
        }
        breadcrumbs={[{ title: "Finanse", path: routes.FINANCES }, { title: "Kategorie płatności" }]}
      />

      <FiltersBackground className="mb-4">
        <div className="flex flex-wrap items-center gap-2">
          <AdminSearchInput onSearch={(sp) => setSearchPhrase(sp)} className="self-end" />
        </div>
      </FiltersBackground>
      <TanTable
        data={categories}
        columns={columns}
        loading={isLoading}
        fetching={isFetching}
        total={total}
        onPaginationChange={onPaginationChange}
        onSortingChange={onSortingChange}
        pagination={pagination}
        sorting={sorting}
        onRowClick={(x) => navigate(routes.COURSE_FINANCES_CATEGORIES_EDIT(x.id))}
        onDelete={(x) => setDeleteResource(x.id)}
      />
      <AdminResourceDeleteModal
        title="Usuń kategorię płatności"
        description="Jesteś pewien że chcesz usunąć tę kategorię? Istniejące płatności zachowają swoją kategorię, ale nie będzie można jej wybrać dla nowych."
        onSuccessDelete={invalidate}
        deleteAction={courseFinanceCategoriesApi.delete}
      />
    </PageMain>
  );
};
